import cn from 'classnames';

import styles from '~/style/aigallery/componentsAndMCPServices.module.less';
import {componentsAndMCPServices as data, moduleTitleCn, moduleContentCn} from '~/locals/aigallery/index';
import {ArrowBtn} from './components';
import {useQfScreen} from '../comp/utils/hook';
import {useCptDuration} from '~/utils/trackCptDuration/hook';
import {applicationName} from '~/utils/trackCptDuration/constants';

const id = 'componentsAndMCPServices';

const ComponentsAndMCPServices = () => {
    const {screenWidth: width} = useQfScreen();
    useCptDuration(id, {
        name: `${applicationName}-组件与MCP服务-停留时长`
    });
    return (
        <div className={styles.container} id={id}>
            <h2 className={cn(styles.title, `${moduleTitleCn}`)}>{data.title}</h2>
            <div className={cn(styles.card, `${moduleContentCn}`)}>
                {data.cardItems.map((item, i) => (
                    <div
                        className={`${styles['card-item']} ${i > 3 ? styles['card-item-last-line'] : null}`}
                        onClick={() => {
                            if (typeof window !== 'undefined') {
                                window?.open?.(item.link, '_blank');
                            }
                        }}
                    >
                        {i > 3 ? null : (
                            <img
                                className={styles['card-item-bg']}
                                src={require(`assets/qf/componentsAndMCPServices/bg${i + 1}.png`).default}
                            />
                        )}
                        {i > 3 ? null : (
                            <img
                                className={styles['card-item-mask']}
                                src={require(`assets/qf/componentsAndMCPServices/mask${i + 1}.png`).default}
                            />
                        )}
                        <img src={item.icon} alt="" className={styles['card-item-icon']} />
                        <div className={styles['card-item-title']}>{item.name}</div>
                        <div className={styles['card-item-tag']}>
                            {item.freeCalls ? (
                                <div
                                    className={`${styles['card-item-tag-item-first']} ${styles['card-item-tag-item']}`}
                                >
                                    <img src={require('assets/qf/componentsAndMCPServices/icon.svg').default} alt="" />
                                    免费调用：{item.freeCalls}
                                </div>
                            ) : null}
                            {item.tags.map((tag, index) => {
                                if (width > 992) {
                                    if ((i === 2 || i === 3) && index === item.tags.length - 1 && width < 1152) {
                                        return null;
                                    }
                                    if ((i === 1 || i === 0) && index === item.tags.length - 1 && width < 1089) {
                                        return null;
                                    }
                                    if (i === 4 && index === item.tags.length - 1 && width < 1029) {
                                        return null;
                                    }
                                }

                                return <div className={styles['card-item-tag-item']}>{tag}</div>;
                            })}
                        </div>
                        <div className={styles['card-item-desc']}>{item.description}</div>
                        <ArrowBtn
                            data={{
                                link: item.link,
                                text: '了解更多',
                                className: styles.arrowBtn,
                                trackInfo: item.trackInfo
                            }}
                        />
                    </div>
                ))}
            </div>
            <div className={cn(styles.btnBox, `${moduleTitleCn}`)}>
                <ArrowBtn
                    data={{
                        link: data.link,
                        text: data.btnText,
                        secondary: true,
                        trackInfo: data.trackInfo
                    }}
                />
            </div>
        </div>
    );
};

export default ComponentsAndMCPServices;
